// src/components/dashboard/RecentEventsTable.tsx
import React from 'react';
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
} from '../ui/table';

interface TrafficEvent {
  id: string;
  botName: string;
  operator: string;
  function: string;
  action: string;
  path: string | null;
  method: string;
  timestamp: string;
}

interface RecentEventsTableProps {
  events: TrafficEvent[];
}

export const RecentEventsTable: React.FC<RecentEventsTableProps> = ({ events }) => {
  if (events.length === 0) {
    return (
      <div className="rounded-xl border border-brand-border p-6">
        <h2 className="text-sm font-medium text-brand-black mb-1">Recent activity</h2>
        <p className="text-sm text-brand-gray">No agent activity yet.</p>
      </div>
    );
  }

  return (
    <div className="rounded-xl border border-brand-border overflow-hidden">
      <div className="px-6 py-4 border-b border-brand-border">
        <h2 className="text-sm font-medium text-brand-black">Recent activity</h2>
      </div>
      <div className="max-h-96 overflow-y-auto">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Time</TableHead>
              <TableHead>Agent</TableHead>
              <TableHead>Operator</TableHead>
              <TableHead>Action</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {events.map((e) => (
              <TableRow key={e.id}>
                <TableCell className="font-mono text-xs text-brand-gray">
                  {new Date(e.timestamp).toLocaleString()}
                </TableCell>
                <TableCell className="text-brand-black">{e.botName}</TableCell>
                <TableCell className="text-brand-charcoal">{e.operator}</TableCell>
                <TableCell className="text-brand-charcoal">{e.function}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};